import { Quote } from '@model/quote';
import { Funding } from '@model/funding';
import { Globals } from '@theme/utils/globals';
import { Production } from '@model/production';
import { Component, OnInit } from '@angular/core';
import { Construction } from '@model/construction';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentFunding } from '@model/payment-funding';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteService } from '@service/quote/quote.service';
import { FilterService } from '@service/filter/filter.service';
import { FundingService } from '@service/funding/funding.service';
import { DateHelperService } from '@theme/utils/date-helper.service';
import { ProductionService } from '@service/production/production.service';
import { ConstructionService } from '@service/construction/construction.service';
import { PaymentFundingService } from '@service/payment-funding/payment-funding.service';
import { ConstructionAddComponent } from '@chantier/construction/construction-add/construction-add.component';
import { NgxPermissionsService } from 'ngx-permissions';
import { InvoiceCo } from '@model/prestataire/invoice-co';
import { InvoiceService } from '@service/invoice/invoice.service';
import { InvoiceCoService } from '@service/invoice-co/invoice-co.service';

@Component({
  selector: 'app-construction-show',
  templateUrl: './construction-show.component.html',
  styleUrls: ['./construction-show.component.scss']
})
export class ConstructionShowComponent implements OnInit {
  public activeTab: string = 'INTERVENTION';
  construction: Construction;
  constructionVal: boolean = false;
  quotes: Quote[];
  bons: Quote[];
  invoices: InvoiceCo[];
  productions: Production[];
  fundings: Funding[];
  payments: PaymentFunding[];
  type: string = 'INTERVENTION';
  name: boolean = true;
  global = { country: Globals.country, device: Globals.device }
  userSession = Globals.user;
  etatRow = [
    { label: 'Disponible', value: 'DISPONIBLE' },
    { label: 'Vendu', value: 'VENDU' }
  ];
  typeRow = [
    { label: 'Intervention', value: 'INTERVENTION' },
    { label: 'Devis', value: 'DEVIS' },
    { label: 'Bon de commande', value: 'BON' },
    { label: 'Financement', value: 'FINANCEMENT' },
    { label: 'Réalisation', value: 'REALISATION' },
    { label: 'Paiement', value: 'PAIEMENT' }
  ];
  categorieRow = [
    { label: 'En location', value: 'LOCATION' },
    { label: 'En vente', value: 'VENTE' }
  ];
  nameTitle: string = "Nom du bien"
  userTitle: string = "Crée par"
  minTitle: string = "Montant MIN"
  maxTitle: string = "Montant MAX"
  categorieTitle: string = "Type de bien"
  etatTitle: string = "Disponibilité ?"

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private quoteService: QuoteService,
    private filterService: FilterService,
    private fundingService: FundingService,
    private invoiceService: InvoiceCoService,
    private productionService: ProductionService,
    private paymentService: PaymentFundingService,
    private constructionService: ConstructionService,
    private permissionsService: NgxPermissionsService
  ) {
    this.construction = this.constructionService.getConstruction()
    this.onChangeLoad(this.type);
    const permission = JSON.parse(localStorage.getItem('permission-zen')) ? JSON.parse(localStorage.getItem('permission-zen')) : [];
    this.permissionsService.loadPermissions(permission);
  }

  ngOnInit(): void {
  }

  onFilter($event) {
    this.quotes = []
    this.productions = []
    this.fundings = []
    this.payments = []
    $event.type = this.activeTab
    this.filterService.search($event, 'construction', this.construction.uuid).subscribe(
      res => {
        if (this.activeTab === 'DEVIS') {
          return this.quotes = res;
        } if (this.activeTab === 'BON') {
          return this.bons = res;
        } if (this.activeTab === 'FACTURE') {
          return this.invoices = res;
        } else if (this.activeTab === 'FINANCEMENT') {
          return this.fundings = res;
        } else if (this.activeTab === 'REALISATION') {
          return this.productions = res;
        } else if (this.activeTab === 'PAIEMENT') {
          return this.payments = res;
        }
      }, err => { })
  }
  onChangeLoad(type): void {
    this.activeTab = type;
    if (type === 'INTERVENTION') {
      if (!this.construction) {
        this.constructionService.getSingle(this.route.snapshot.params.id).subscribe((res: any) => {
          return this.construction = res?.data;
        });
      }
    } else if (type === 'DEVIS') {
      this.typeRow = [{ label: 'Devis', value: 'DEVIS' }];
      this.name = false;
      this.nameTitle = 'Libellé'
      this.etatTitle = 'État'
      this.categorieTitle = 'Type'
      this.etatRow = [
        { label: 'Valide', value: 'VALIDE' },
        { label: 'Invalide', value: 'INVALIDE' }
      ];
      this.categorieRow = [
        { label: 'Pestation', value: 'PRESTATION' },
        { label: 'Fourniture', value: 'FOURNITURE' }
      ];
      this.quoteService.getList(this.construction.uuid, 'PRESTATION').subscribe((res) => {
        return this.quotes = res;
      }, error => { }
      );
    } else if (type === 'BON') {
      this.typeRow = [{ label: 'Bon de commande', value: 'BON' }];
      this.name = false;
      this.nameTitle = 'Libellé'
      this.etatTitle = 'État'
      this.categorieTitle = 'Type'
      this.etatRow = [
        { label: 'Valide', value: 'VALIDE' },
        { label: 'Invalide', value: 'INVALIDE' }
      ];
      this.categorieRow = [
        { label: 'Fourniture', value: 'FOURNITURE' }
      ];
      this.quoteService.getList(this.construction.uuid, 'PRESTATION',null, 1).subscribe((res) => {
        return this.bons = res;
      }, error => { }
      );
    } else if (type === 'FACTURE') {
      this.typeRow = [{ label: 'Facture', value: 'FACTURE' }];
      this.name = false;
      this.nameTitle = 'Libellé'
      this.etatTitle = 'État'
      this.categorieTitle = 'Type'
      this.etatRow = [
        { label: 'Valide', value: 'VALIDE' },
        { label: 'Invalide', value: 'INVALIDE' }
      ];
      this.categorieRow = [
        { label: 'Facture', value: 'FACTURE' }
      ];
      this.invoiceService.getList(this.construction.uuid, 'PRESTATION').subscribe((res) => {
        return this.invoices = res;
      }, error => { }
      );
    } else if (type === 'FINANCEMENT') {
      this.name = false;
      this.categorieTitle = 'Financeur'
      this.etatTitle = 'État'
      this.typeRow = [{ label: 'Financement', value: 'FINANCEMENT' }];
      this.categorieRow = [
        { label: 'Agence', value: 'AGENCE' },
        { label: 'Bailleurs', value: 'PROPRIETAIRE' }
      ];
      this.etatRow = [
        { label: 'Valide', value: 'VALIDE' },
        { label: 'Invalide', value: 'INVALIDE' }
      ];
      this.fundingService.getList(this.construction.uuid).subscribe((res) => {
        return this.fundings = res;
      }, error => { }
      );
    } else if (type === 'REALISATION') {
      this.name = false
      this.typeRow = [{ label: 'Réalisation', value: 'REALISATION' }];
      this.categorieRow = []
      this.productionService.getList(this.construction.uuid).subscribe((res) => {
        return this.productions = res;
      }, error => { }
      );
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Valide', value: 'VALIDE' },
        { label: 'Invalide', value: 'INVALIDE' }
      ];
    } else if (type === 'PAIEMENT') {
      this.typeRow = [{ label: 'Paiement', value: 'PAIEMENT' }];
      this.categorieRow = []
      this.paymentService.getList(null, this.construction.uuid).subscribe((res) => {
        return this.payments = res;
      }, error => { }
      );
    }
  }
  editConstruction(row) {
    this.constructionService.setConstruction(row);
    this.constructionService.edit = true;
    this.constructionService.type = row.type;
    this.modal(ConstructionAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  printerConstruction(row): void {
    this.constructionService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  back() { this.router.navigate(['/admin/intervention']) }
  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) { }
      else {
        this.constructionService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') { this.router.navigate(['/admin/intervention']) }
        });
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }
  formatDate(date): string {
    return DateHelperService.fromJsonDate(date);
  }

  timelapse(dateD, dateF): string {
    return DateHelperService.getTimeLapse(dateD, dateF, false, 'dmy');
  }

}
